export default "__VITE_ASSET__DQKiCwpg__"